<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div
  class="form-group xrx-redact portal-wrapper"
  [ngClass]="{
    'automated-wrapper': isAutomated,
  }">
  @if (!isMfd) {
    <div [ngClass]="{ 'service-params': !isAutomated }">
      <div class="location-select">
        <xrx-select
          [label]="'SDE_LOCATION'"
          [list]="countries"
          [(selectedItem)]="selectedCountry"
          [localize]="'value'"
          [property]="'key'"
          [orderby]="'key'"
          (change)="onCountrySelected()"
          [isInputOnly]="true">
        </xrx-select>
      </div>
      <div>
        <xrx-select
          [label]="'SDE_MARKUP_TYPE'"
          [list]="markupTypes.options"
          [(selectedItem)]="markupTypes.selectedValue"
          [localize]="'key'"
          [property]="'value'"
          (change)="onMarkupSelected()"
          [isInputOnly]="true">
        </xrx-select>
      </div>
    </div>
  }

  @if (!isMfd) {
    <div class="h-divider"></div>
  }

  <!-- Standard Fields -->
  <div>
    <xrx-toggle-switch-group
      [isMfd]="isMfd"
      [label]="standardFieldsLabel"
      [list]="defaultFields"
      [labelKey]="'displayText'"
      [valueKey]="'toggled'"
      (change)="onDefaultFieldChange()">
    </xrx-toggle-switch-group>
  </div>

  @if (!isMfd) {
    <div class="form-group mt-4">
      <button
        type="button"
        class="xrx-btn add-edit-btn btn-secondary w-add-btn"
        (click)="editPreferredList()"
        [disabled]="isLoading">
        @if (defaultFields.length === 0) {
          <span class="btn-label" [xdaTranslate]="'SDE_ADD'"></span>
        }
        @if (defaultFields.length !== 0) {
          <span class="btn-label" [xdaTranslate]="'SDE_ADD_EDIT'"></span>
        }
      </button>
    </div>
  }

  @if (!isMfd) {
    <div class="h-divider"></div>
  }

  <!-- Custom added strings -->
  <section>
    <form #customWordForm="ngForm">
      @if (!isMfd && !isAutomated) {
        <div class="form-group mt-4 custom-word-group">
          <label
            for="cw-{{ customFields[0]?.id }}"
            [xdaTranslate]="'SDE_CUSTOM_WORD_PHRASE'"></label>
          @for (cf of customFields; track cf; let i = $index) {
            <div class="form-group d-flex">
              <xrx-input
                type="text"
                name="custom-word{{ cf.id }}"
                id="cw-{{ cf.id }}"
                [(ngModel)]="cf.text"
                placeholder="SDE_ENTER_CUSTOM_WORD"
                (change)="onCustomWordChange($event)"
                [autofocus]="cf.text.length === 0"
                class="custom-word w-100">
              </xrx-input>
              <xrx-select
                [isMfd]="isMfd"
                [list]="matchOptions"
                [(selectedItem)]="cf.selectedValue"
                [localize]="'key'"
                [property]="'value'"
                [orderby]="'key'"
                (change)="onMatchCriteriaChange()"
                class="match-criteria">
              </xrx-select>
              <span class="delete_custom_word_btn"
                ><i
                  class="xgl-subtract_circle xglsize-24 minus-button"
                  tabindex="0"
                  (click)="removeCustomWord(i)"
                  (keydown.enter)="removeCustomWord(i)"
                  (keydown.space)="removeCustomWord(i)"></i
              ></span>
            </div>
          }
          @if (customFieldIsInvalid) {
            <div class="invalid-feedback">
              <span [xdaTranslate]="'SDE_REQUIRED_FIELD1'"></span>
            </div>
          }
          <div class="xrx-pt-3">
            <button
              type="button"
              class="xrx-btn btn-secondary w-add-btn keep-border"
              (click)="addCustomWord()"
              [disabled]="cwFormIsInvalid || isLoading">
              <span class="btn-label" [xdaTranslate]="'SDE_ADD'"></span>
            </button>
          </div>
          @if (defaultFieldIsInvalid) {
            <div>
              <span
                class="text-danger"
                [xdaTranslate]="'SDE_REQUIRED_FIELD1'"></span>
            </div>
          }
        </div>
      }

      @if (!isMfd && isAutomated) {
        <div class="form-group mt-4 custom-word-group">
          <label
            for="cw-{{ customFields[0]?.id }}"
            [xdaTranslate]="'SDE_CUSTOM_WORD_PHRASE'"></label>
          @for (cf of customFields; track cf; let i = $index) {
            <div class="form-group d-flex align-items-center">
              <div class="d-flex flex-column custom-word-wrapper w-100">
                <xrx-input
                  type="text"
                  name="custom-word{{ cf.id }}"
                  id="cw-{{ cf.id }}"
                  [(ngModel)]="cf.text"
                  placeholder="SDE_ENTER_CUSTOM_WORD"
                  (change)="onCustomWordChange($event)"
                  [autofocus]="cf.text.length === 0"
                  class="custom-word w-100">
                </xrx-input>
                <xrx-select
                  [isMfd]="isMfd"
                  [list]="matchOptions"
                  [(selectedItem)]="cf.selectedValue"
                  [localize]="'key'"
                  [property]="'value'"
                  [orderby]="'key'"
                  (change)="onMatchCriteriaChange()"
                  class="match-criteria w-100">
                </xrx-select>
              </div>
              <span class="d-flex delete_custom_word_btn justify-content-center"
                ><i
                  class="xgl-subtract_circle xglsize-24 minus-button"
                  tabindex="0"
                  (click)="removeCustomWord(i)"
                  (keydown.enter)="removeCustomWord(i)"
                  (keydown.space)="removeCustomWord(i)"></i
              ></span>
            </div>
          }
          @if (customFieldIsInvalid) {
            <div class="invalid-feedback">
              <span [xdaTranslate]="'SDE_REQUIRED_FIELD1'"></span>
            </div>
          }
          <div class="xrx-pt-3">
            <button
              type="button"
              class="xrx-btn btn-secondary w-add-btn keep-border"
              (click)="addCustomWord()"
              [disabled]="cwFormIsInvalid || isLoading">
              <span class="btn-label" [xdaTranslate]="'SDE_ADD'"></span>
            </button>
          </div>
          @if (defaultFieldIsInvalid) {
            <div>
              <span
                class="text-danger"
                [xdaTranslate]="'SDE_REQUIRED_FIELD1'"></span>
            </div>
          }
        </div>
      }
    </form>
  </section>
</div>
